import { render, staticRenderFns } from "./RelatorioClientePreview.vue?vue&type=template&id=478298c4&scoped=true"
import script from "./RelatorioClientePreview.vue?vue&type=script&lang=js"
export * from "./RelatorioClientePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478298c4",
  null
  
)

export default component.exports